import React, { Fragment, useEffect, useState } from 'react'
import useStyles from './styles'

import Button from '@material-ui/core/Button'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'

import { useTranslation } from 'react-i18next'

import CircularProgress from '@material-ui/core/CircularProgress'
import { connect } from 'react-redux'
import { operatorActions } from '../../../../redux/actions/operator_action'
import { techniciansActions } from '../../../../redux/actions/technicians_action'

const RegisterOperatorManager = ({
  insert,
  operatorReducer,
  userReducer,
  getUserDataByEmail,
}) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const { insertPending, insertFailure, insertSuccess } = operatorReducer
  const [password, setpassword] = useState('')
  const [phoneNumber, setphoneNumber] = useState('')
  const [username, setusername] = useState('')
  const [firstName, setfirstName] = useState('')
  const [lastName, setlastName] = useState('')
  const [email, setemail] = useState('')
  const [repeatPassword, setrepeatPassword] = useState('')
  const [helpertextrepeatPassword, sethelpertextrepeatPassword] =
    useState(false)

  useEffect(() => {
    sethelpertextrepeatPassword(password === repeatPassword)
  }, [repeatPassword, password])

  const handleSubmit = () => {
    const body = {
      sharingOperatorId: operatorReducer.dataOperatorLogged.id,
      username: email,
      password: password,
      email: email,
      mobilePhone: phoneNumber.includes('+34')
        ? phoneNumber
        : `+34${phoneNumber}`,
      firstName: firstName,
      lastName: lastName,
    }
    insert(body)
  }

  useEffect(() => {
    if (insertSuccess) {
      setemail('')
      setpassword('')
      setphoneNumber('')
      setusername('')
      setfirstName('')
      setlastName('')
    }
  }, [insertSuccess])

  const handleChangeMail = (email) => {
    setemail(email)
  }

  useEffect(() => {
    getUserDataByEmail(email)
  }, [email])

  useEffect(() => {
    operatorReducer.userPendingToCreateExist && setpassword(null)
  }, [operatorReducer.userPendingToCreateExist])

  return (
    <Container component="main" maxWidth="md">
      <div className={classes.paper}>
        {/* <Typography component="h1" variant="h5">
          {t("operator.register.technicianUser.header")}
        </Typography> */}
        {insertPending ? (
          <div style={{ 'margin-top': '10%' }}>
            <CircularProgress />
          </div>
        ) : (
          <Fragment>
            <Grid container spacing={2}>
              {/* <Grid item xs={12}>
                <TextField
                  // variant="outlined"
                  required
                  fullWidth
                  label={t("operator.register.technicianUser.username")}
                  value={username}
                  onChange={(e) => setusername(e.target.value)}
                />
              </Grid> */}
              <Grid item xs={12} sm={6}>
                <TextField
                  // variant="outlined"
                  required
                  fullWidth
                  label={t('operator.register.technicianUser.firstName')}
                  value={firstName}
                  onChange={(e) => setfirstName(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  // variant="outlined"
                  required
                  fullWidth
                  label={t('operator.register.technicianUser.lastName')}
                  value={lastName}
                  onChange={(e) => setlastName(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={12}>
                {/* {userReducer.userMailRequestPending ? <LinearProgress style={{ marginTop: "30px" }} /> : 'textField'} */}
                <TextField
                  // variant='standard'
                  required
                  fullWidth
                  label={t('operator.register.technicianUser.email')}
                  autoFocus
                  value={email}
                  onChange={(e) => handleChangeMail(e.target.value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  // variant='standard'
                  required
                  fullWidth
                  type="password"
                  label={t('operator.register.technicianUser.password')}
                  disabled={operatorReducer.userPendingToCreateExist}
                  value={password}
                  onChange={(e) => setpassword(e.target.value)}
                  helperText={
                    operatorReducer.userPendingToCreateExist
                      ? t(
                          'operator.register.technicianUser.helperTextPasswordField',
                        )
                      : ''
                  }
                  error={operatorReducer.userPendingToCreateExist}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                {/* {userReducer.userMailRequestPending ? <LinearProgress style={{ marginTop: "30px" }} /> : 'textField'} */}
                <TextField
                  // variant='standard'
                  required
                  fullWidth
                  type="password"
                  label={t('operator.register.operatorManager.password')}
                  disabled={operatorReducer.userPendingToCreateExist}
                  value={repeatPassword}
                  onChange={(e) => setrepeatPassword(e.target.value)}
                  helperText={
                    !helpertextrepeatPassword &&
                    !operatorReducer.userPendingToCreateExist &&
                    t(
                      'operator.register.operatorManager.helperTextRepeatPassword',
                    )
                  }
                  error={
                    !helpertextrepeatPassword &&
                    !operatorReducer.userPendingToCreateExist
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  // variant="outlined"
                  required
                  fullWidth
                  disabled={userReducer.userMailExist}
                  label={t('operator.register.technicianUser.phoneNumber')}
                  value={phoneNumber}
                  onChange={(e) => setphoneNumber(e.target.value)}
                />
              </Grid>
            </Grid>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={() => handleSubmit()}
            >
              {t('operator.register.technicianUser.submitBtn')}
            </Button>
          </Fragment>
        )}
      </div>
    </Container>
  )
}

const actionCreators = {
  insert: techniciansActions.insert,
  getUserDataByEmail: operatorActions.getUserDataByEmail,
}
function mapState(state) {
  const { operatorReducer, userReducer } = state
  return { operatorReducer, userReducer }
}

export default connect(mapState, actionCreators)(RegisterOperatorManager)
